const getImageValue = (list, variety) => {
    const image = list.find((item) => item.variety === variety);
    return image ? image.source : '';
};

export default getImageValue;
